import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import IconButton from '@material-ui/core/IconButton/IconButton';
import Grid from '@material-ui/core/Grid/Grid';
import {
    IconLastPage,
    IconChevronLeft,
    IconSearch,
    IconPencil,
    IconForward,
    IconDone,
    IconNearMe,
} from '../Icons';
import ButtonBase from '@material-ui/core/ButtonBase/ButtonBase';
// import Button from '@material-ui/core/Button/Button';
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment';
import TextField from '@material-ui/core/TextField/TextField';

const padding = 10;
const dark = '#333333';
const styles = {
    section: {
        position: 'relative',
        paddingTop: 36,
        background: dark,
        //boxShadow: '0 1px 3px 1px #777777',
        // '@media print': {
        //     display: 'none'
        // }
    },

    tableScroll: {
        //height: '72vh',
        height: '100%',
        //height: 400,
        overflowY: 'auto',
        background: '#fff',
    },
    table: {
        margin: 0,
        //paddingBottom: 10,
        fontFamily: 'arial',
        borderCollapse: 'collapse',
        width: '100%',
        border: '1px solid #333',
        '& td': {
            fontSize: 13,
            padding: padding,
            border: '1px solid #cccccc',
        },
        '& td:first-child': {
            background: '#dadada',
        },
    },
    row: {
        '&:hover': {
            backgroundColor: '#f4f4f4',
        },
    },
    thead: {
        '& th': {
            height: 0,
            lineHeight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            // visibility: 'hidden',
            color: 'transparent',
            backgroundColor: 'transparent',
            border: 'none',
            whiteSpace: 'nowrap',
        },
        '& th:first-child': {
            width: 8,
        },
    },
    pseudoTh: {
        fontSize: 14,
        fontWeight: 500,
        position: 'absolute',
        background: 'transparent',
        color: '#fff',
        padding: 10,
        top: 0,
        lineHeight: 'normal',
        borderLeft: '1px solid #ccc',
        cursor: 'pointer',
    },
    pseudoThFirst: {
        borderLeft: 'none',
        cursor: 'auto',
    },
    sortIcon: {
        position: 'absolute',
        marginLeft: 4,
        marginTop: -2,
    },
    footer: {
        background: '#dadada',
        paddingRight: 10,
    },
    button: {
        // padding: '0px !important',
        padding: 6,
        margin: '1px 0',
    },
    flip: {
        transform: 'rotate(180deg)',
    },
    searchGrid: {
        paddingLeft: 8,
        width: 160,
        // paddingBottom: 6
    },
    td: {
        '& actiontd': {
            padding: 0,
            backgroundColor: '#f00',
        },
    },
    actiontd: {
        padding: 0,
    },
    selectedRow: {
        backgroundColor: '#eaeaea',
    },
    doneMsg: {
        color: '#00b300',
    },
    '@media print': {
        section: {
            paddingTop: 0,
        },
        pseudoTh: {
            display: 'none',
        },
        thead: {
            '& th': {
                lineHeight: 'normal',
                color: '#000',
                padding: 12,
                border: '1px solid #000',
                textAlign: 'left',
            },
        },
        printVisible: {
            visibility: 'visible',
        },
        printHidden: {
            visible: 'hidden',
        },
        table: {
            width: '99%',
            '& td': {
                border: '1px solid #000',
            },
        },
    },
};

class TableAdv extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            sort: {
                key: 'id',
                orderAsc: true,
            },
            selectedRowInd: -1,
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (!prevState.length) {
            return {
                data: nextProps.data,
            };
        }
        return null;
    }

    getSorted(valueType, key) {
        const data = this.state.data;

        const sortOrder = this.state.sort.orderAsc;

        if (valueType === 1) {
            return data.sort((a, b) =>
                sortOrder
                    ? b[key].toLowerCase() < a[key].toLowerCase()
                    : b[key].toLowerCase() > a[key].toLowerCase()
            );
        } else {
            return data.sort((a, b) =>
                sortOrder
                    ? parseFloat(a[key]) < parseFloat(b[key])
                    : parseFloat(a[key]) > parseFloat(b[key])
            );
        }
    }
    initSort(key, valueType) {
        const data = this.getSorted(valueType, key);
        this.setState({
            data: data,
            sort: {
                orderAsc:
                    this.state.sort.key === key
                        ? !this.state.sort.orderAsc
                        : false,
                key: key,
            },
        });
    }

    onRowSelect = (index, uid) => {
        this.props.onSelect(uid);
        this.setState({
            selectedRowInd: index,
        });
    };

    render() {
        const {
            header,
            data,
            classes,
            paginate,
            onSelect,
            toolbarComponent,
            action1,
            action2, //edit
        } = this.props;
        const { selectedRowInd } = this.state;

        return (
            <section
                className={classes.section}
                style={{ height: paginate ? '89%' : '93%' }}
            >
                <div className={classes.tableScroll}>
                    <table className={classes.table} id="fixed-header">
                        <thead className={classes.thead}>
                            <tr>
                                <th>
                                    #
                                    <div
                                        className={`${classes.pseudoTh} ${
                                            classes.pseudoThFirst
                                        }`}
                                    >
                                        #
                                    </div>
                                </th>
                                {header.map((h, ind) => (
                                    <th key={ind}>
                                        {h.label}
                                        <div
                                            className={classes.pseudoTh}
                                            onClick={() =>
                                                this.initSort(h.key, h.type)
                                            }
                                        >
                                            {h.label}
                                            {this.state.sort.key === h.key ? (
                                                this.state.sort.orderAsc ? (
                                                    <i
                                                        className={
                                                            classes.sortIcon
                                                        }
                                                    >
                                                        ↑
                                                    </i>
                                                ) : (
                                                    <i
                                                        className={
                                                            classes.sortIcon
                                                        }
                                                    >
                                                        ↓
                                                    </i>
                                                )
                                            ) : (
                                                <i
                                                    className={classes.sortIcon}
                                                />
                                            )}
                                        </div>
                                    </th>
                                ))}

                                <th colSpan="3" />
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((f, ind) => (
                                <tr
                                    key={ind}
                                    className={
                                        selectedRowInd === ind
                                            ? classes.selectedRow
                                            : classes.row
                                    }
                                >
                                    {/* <tr key={ind} className={selectedRow ? classes.selectedRow : ''}> */}
                                    <td>{ind + 1}</td>
                                    {header.map((h, ind2) => (
                                        <td key={ind2}>{f[h.key]}</td>
                                    ))}

                                    {/* SELECT BUTTON */
                                    onSelect !== undefined && (
                                        <td style={{ padding: 0 }}>
                                            <ButtonTRow
                                                onTap={() =>
                                                    this.onRowSelect(ind, f.uid)
                                                }
                                                label="Select"
                                                Icon={IconForward}
                                            />
                                        </td>
                                    )}

                                    {/* ACTION 2 */
                                    action1 !== undefined && (
                                        /* <Action1
                                            action1={action1}
                                            id={f.uid}
                                            param={f.currPaid}
                                            Icon={IconNearMe}
                                        /> */
                                        <td style={{padding: 0}}>
                                            <ButtonTRow label="Pay" onTap={() => action1(f.uid)} />
                                        </td>
                                    )}

                                    {action2 !== undefined && (
                                        <td style={{ padding: 0 }}>
                                            <ButtonTRow
                                                label="Edit"
                                                Icon={IconPencil}
                                                onTap={() => action2(f.uid)}
                                            />
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {paginate && (
                    <div className="print-hidden">
                        <Grid
                            container
                            justify="space-between"
                            className={classes.footer}
                        >
                            <Grid className={classes.searchGrid} item>
                                <TextField
                                    placeholder="Search..."
                                    autoFocus={true}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <IconSearch />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item>{toolbarComponent}</Grid>
                            <Grid item>
                                <IconButton
                                    className={`${classes.button} ${
                                        classes.flip
                                    }`}
                                >
                                    <IconLastPage />
                                </IconButton>

                                <IconButton className={classes.button}>
                                    <IconChevronLeft />
                                </IconButton>

                                <IconButton
                                    className={`${classes.button} ${
                                        classes.flip
                                    }`}
                                >
                                    <IconChevronLeft />
                                </IconButton>

                                <IconButton className={classes.button}>
                                    <IconLastPage />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </div>
                )}
            </section>
        );
    }
}

TableAdv.propTypes = {
    header: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    paginate: PropTypes.bool,
};

export default withStyles(styles)(TableAdv);

/**
 * HEADER OBJECT FORMAT
 * {
 * id: unique identifier for operation (not shown in table values)
 * label: string, (display label )
 * key: string, (sort key)
 * type: integer ( determines whether to sort by string method or number method), 1 for string, 2 for number
 * }
 */

const Action1 = ({ action1, id, param, Icon }) => (
    <td style={{ padding: 0 }}>
        {!param ? (
            <ButtonTRow
                onTap={() => action1.action(id)}
                label={action1.labelDefault}
                Icon={Icon}
            />
        ) : (
            <Grid
                style={{ color: '#00b300', paddingLeft: 8 }}
                alignItems="center"
                container
            >
                <IconDone style={{ fontSize: 16, fontWeight: 700 }} />{' '}
                {action1.labelDone}
            </Grid>
        )}
    </td>
);

const styles2 = theme => ({
    btn: {
        padding: 8,
        marginLeft: 1,
        color: theme.palette.primary.dark,
        '&:hover': {
            // backgroundColor: theme.palette.primary.light,
            backgroundColor: '#eaeaea',
            // color: '#fff',
        },
    },
    icon: {
        marginRight: 2,
        '& i': {
            fontSize: 16,
        },
    },
});

const ButtonTRow1 = ({ classes, Icon, onTap, label }) => (
    <ButtonBase className={classes.btn} onClick={onTap}>
        <Grid alignItems="center" container>
            {Icon && (
                <Grid className={classes.icon} item>
                    <Icon />
                </Grid>
            )}
            <Grid item>{label}</Grid>
        </Grid>
    </ButtonBase>
);
const ButtonTRow = withStyles(styles2)(ButtonTRow1);
